module.exports = __webpack_public_path__ + "static/assets/dfbc5f2e69ac1e10d82bc3ae038e2eab.png";